import React, { useEffect, useState } from 'react';
import {
  Box,
  Tab,
  Tabs,
  Slider,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
// import { BarChart, LineChart } from '@mui/x-charts';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import {
  setIsExportToCsv,
  setShowTable,
  setShowTrendLine,
  updateSelectedFilter,
} from 'src/slices/filterSlice';
import {
  selectisExportToCsv,
  selectSelectedFilter,
  selectShowTable,
  selectShowTrendLine,
} from 'src/app/selectors/filterSelectors';
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { generateRandomColor, getAggregationForTicks } from 'src/utils/Utils';
import CustomTooltip from './CustomTooltip';
import FunnelView from 'src/pages/FunnelView/FunnelView';
import { calculateXTicks } from 'src/utils/xTicks';

interface LargeGraphProps {
  data: { x: number; y: number; value: number }[];
  width?: number;
  height?: number;
}

export const LargeGraph: React.FC<LargeGraphProps> = ({
  graphData,
  config,
}) => {
  const dispatch = useDispatch();
  const theme = useTheme(); // Access the theme
  const isShowTable = useSelector(selectShowTable);
  const { channel, store, machine_type, start, end } = useSelector(selectSelectedFilter);

  const isBar = config.graphType === 'bar';
  const isShowTrendLine = useSelector(selectShowTrendLine);
  const isExportToCsv = useSelector(selectisExportToCsv);
  const primaryColor = theme.palette.primary.main; // Get primary color
  const [tabValue, setTabValue] = useState('daily');
  const [anchorEl, setAnchorEl] = useState(null);
  const selectedStores = store && store.length > 0 ? store?.split(',') : [];
  const seelctedMachineTypes = machine_type && machine_type.length > 0 ?  machine_type?.split(',') : []
  const selectedChannels =
    channel && channel.length > 0 ? channel?.split(',') : [];
  let graphMultiDataKeys = selectedChannels;
  if (seelctedMachineTypes.length >= 1) {
    graphMultiDataKeys = seelctedMachineTypes;
  }
  if (selectedStores.length >= 1) {
    graphMultiDataKeys = selectedStores;
  }

  const [sliderValue, setSliderValue] = useState([
    0,
    config.graphType === 'funnel' ? graphData.length : graphData[0].data.length,
  ]);
  let data = [];
  if (config.graphType === 'funnel') {
    data = graphData;
  } else {
    data = graphData[0].data.map((item, index) => ({
      x: config.value(item.x),
      y: item.y | item.value | item.Sessions,
      value: item.value | item.Transactions,
      formattedxValue: config.xFormat(item.x),
      formattedyValue: config.yFormat(item.y),
      ...item,
      y_mavg: isShowTrendLine ? graphData[1]?.mavgData[index]?.y_mavg : 0,
      sum:
        graphData[0].prodrevenue_sum |
        graphData[0].prodrevenue_sum |
        graphData[0].tax_collected_sum,
    }));
    if (data && data.length > 0 && data[0].value) {
      data = data
        .filter((item) => item.y > 0 && item.value)
        .sort((a, b) => b.y - a.y);
    }
  }
  const slicedData = data.slice(sliderValue[0], sliderValue[1] + 1);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    dispatch(updateSelectedFilter({ key: 'aggregation', value: newValue }));
  };

  const handleSliderChange = (event, newValue) => {
    setSliderValue(newValue);
  };
  useEffect(() => {
    setSliderValue([0, data.length]);
  }, [graphData]);

  const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const handleMenuTable = () => {
    dispatch(setShowTable(!isShowTable));
    handleMenuClose();
  };

  const handleTrendLine = () => {
    dispatch(setShowTrendLine(!isShowTrendLine));
    handleMenuClose();
  };
  const handleExportToCSV = () => {
    dispatch(setIsExportToCsv(!isExportToCsv));
    handleMenuClose();
  };

  if (!data || data.length === 0) return <p>No data available</p>;
  let xTicks:number[] = [];
  if(data.x){
    const xValues = data.map((item:any) => item.x);
    xTicks = calculateXTicks(xValues, getAggregationForTicks(tabValue)); // Calculate ticks for a monthly interval
    console.log('oooooooo',xTicks)
    
  }
  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      {config.graphType === 'funnel' ? (
        <></>
      ) : (
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box sx={{ ml: 'auto' }}>
            {' '}
            {/* Forces tabs to float to the right */}
            <Tabs value={tabValue} onChange={handleTabChange}>
              <Tab label="Hourly" value="hourly" sx={{ textTransform: 'capitalize', fontsize: '0.9rem' }}  />
              <Tab label="Daily" value="daily" sx={{ textTransform: 'capitalize', fontsize: '0.9rem' }}  />
              <Tab label="Weekly" value="weekly" sx={{ textTransform: 'capitalize', fontsize: '0.9rem' }}  />
              <Tab label="Monthly" value="monthly" sx={{ textTransform: 'capitalize', fontsize: '0.9rem' }}  />
            </Tabs>
          </Box>
          <IconButton onClick={handleMenuClick}>
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleMenuTable}>Table</MenuItem>
            <MenuItem onClick={handleTrendLine}>Trendline</MenuItem>
            <MenuItem onClick={handleExportToCSV}>Export as CSV</MenuItem>
          </Menu>
        </Box>
      )}

      {config.graphType === 'funnel' ? (
        <FunnelView data={graphData} isTile={false} />
      ) : (
        <ResponsiveContainer width="99%" height={300}>
          {isBar ? (
            <BarChart
            data={slicedData}
            height={300}
            barCategoryGap="30%" // Adjusted for better spacing between bars
            margin={{ top: 20, right: 20, left: 20, bottom: 20 }} // Improved margins for better spacing
          >
            {/* Background grid */}
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
          
            {/* X-Axis configuration */}
            <XAxis
              dataKey={(item) => config.value(item.x)}
              angle={-45} // Rotate labels for better readability
              interval={0}
              textAnchor="end"
              height={80}
              tickFormatter={(value) => {
                // Extract first and last word, separate by '...'
                const words = value.split(" ");
                if (words.length > 1) {
                  return `${words[0]}...${words[words.length - 1]}`;
                }
                return value; // If only one word, return as is
              }}
              tick={{ fontSize: 12 }}
            />
          
            {/* Y-Axis configuration */}
            <YAxis
              tickFormatter={(value) => config.yFormat(value)}
              tick={{ fontSize: 12 }}
            />
          
            {/* Tooltip for interactivity */}
            <Tooltip
              content={
                <CustomTooltip
                  xFormat={config.xFormat}
                  yFormat={config.yTooltipFormat}
                  toolTip = {config.toolTip}
                />
              }
            />
          
            {/* Single bar with a clean style */}
            <Bar
              dataKey="y"
              stackId="a"
              fill={primaryColor}
              barSize={20}
            />
            {/* <Bar dataKey="value" stackId="a" fill={generateRandomColor()} /> */}

            {(config.title_key === "Time of Day" || config.title_key === "Time of Week") ? (
            //  <Bar dataKey="value" stackId="a" fill={generateRandomColor()} />
            <Bar dataKey="value" stackId="a" fill= "rgb(255, 186, 0)" />
            ) : null}
            
          </BarChart>          
          ) : (
            <LineChart data={slicedData} height={300} syncId="anyId">
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
               // dataKey={(item) => config.value(item.x)}
                dataKey ={'x'}
                ticks={xTicks}
                // axisLine={{ stroke: 'transparent' }}
                // tickSize={12}
                // tickLine={{ stroke: 'transparent' }}
                tick={{ fontSize: 12 }}
                angle={-45}
                //interval="equidistantPreserveStart"
                textAnchor="end"
                height={80}
                // Format X-axis values (e.g., convert timestamps to readable dates)
                tickFormatter={(value) => config.xFormat(value, false)} 
              />
              <YAxis
                tickFormatter={(value) => {
                  // Format X-axis values (e.g., convert timestamps to readable dates)
                  return config.yFormat(value);
                }}
              />
              <Tooltip
                // cursor={{ stroke: APP_COLORS.main, strokeWidth: TOOLTIP_CURSOR_WIDTH }}
                isAnimationActive={false}
                content={
                  <CustomTooltip
                    xFormat={config.xFormat}
                    yFormat={config.yTooltipFormat}
                    toolTip = {config.toolTip}
                  />
                }
              />
              <Legend
                height={44}
                align="left"
                verticalAlign="top"
                iconType="circle"
                iconSize={12}
                wrapperStyle={{ left: 24 }}
              />
              {graphMultiDataKeys.length > 0 ? (
                graphMultiDataKeys.map((item, index) => (
                  <Line
                    key={index}
                    type="linear"
                    dataKey={item}
                    stroke={index == 0 ? primaryColor : generateRandomColor()}
                    strokeWidth={1.5}
                    dot={false}
                    name={item}
                  />
                ))
              ) : (
                <Line
                  type="linear"
                  dataKey="y"
                  stroke={primaryColor}
                  strokeWidth={1.5}
                  dot={false}
                  name="All Stores"
                />
              )}
              {isShowTrendLine && (
                <Line
                  type="linear"
                  dataKey="y_mavg"
                  stroke="red"
                  strokeWidth={1.5}
                  name="Trendline"
                  dot={false}
                />
              )}
            </LineChart>
          )}
        </ResponsiveContainer>
      )}
      {/* Slider for selecting data range */}
      {config.graphType === 'funnel' ? (
        <></>
      ) : (
        <Box
          sx={{
            position: 'relative',
            //marginTop: '20px',
            marginLeft: 5,
            marginRight: 5,
          }}
        >
          <Slider
            value={sliderValue}
            onChange={handleSliderChange}
            min={0}
            max={data.length - 1}
            valueLabelDisplay="auto"
          />
        </Box>
      )}
    </Box>
  );
};
